import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = { class: "lozenge-left" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "lozenge-text" };
const _hoisted_5 = { class: "lozenge-value" };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategoryLozenge',
    props: {
        categoryName: {},
        categoryIcon: { default: 'mdi-briefcase-outline' },
        iconPath: { default: null },
        iconColour: { default: null },
        disabled: { type: Boolean, default: false },
        disabledLabel: { default: '' }
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const iconImageSrc = computed(() => {
            if (!props.iconPath)
                return null;
            try {
                return require('@/assets/transactions/' + props.iconPath.toLowerCase().replace('.svg', '.png'));
            }
            catch {
                return null;
            }
        });
        const iconCircleStyle = computed(() => {
            if (props.iconColour)
                return { background: props.iconColour };
            return undefined;
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["category-lozenge", { disabled: _ctx.disabled }]),
                disabled: _ctx.disabled,
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('click')))
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "category-icon-circle",
                        style: _normalizeStyle(iconCircleStyle.value)
                    }, [
                        (iconImageSrc.value)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "category-icon-img",
                                src: iconImageSrc.value,
                                alt: ""
                            }, null, 8, _hoisted_3))
                            : (_openBlock(), _createBlock(_component_v_icon, {
                                key: 1,
                                size: "16",
                                color: "white"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.categoryIcon), 1)
                                ]),
                                _: 1
                            }))
                    ], 4),
                    _createElementVNode("div", _hoisted_4, [
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "lozenge-label" }, "Category", -1)),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.disabled && _ctx.disabledLabel ? _ctx.disabledLabel : _ctx.categoryName), 1)
                    ])
                ]),
                _createVNode(_component_v_icon, {
                    size: "12",
                    color: "white"
                }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("mdi-chevron-down")
                    ])),
                    _: 1
                })
            ], 10, _hoisted_1));
        };
    }
});
